export default __webpack_public_path__ + "images/screenshot-search-dd91707.png";